import { Link } from 'react-router-dom';
import { Radio, ChevronLeft } from 'lucide-react';

export default function RadioPage() {
  return (
    <div className="min-h-screen bg-slate-950" data-testid="radio-page">
      <div className="max-w-3xl mx-auto px-4 pt-8 pb-16">

        <Link to="/" className="inline-flex items-center gap-1.5 text-xs text-slate-500 hover:text-slate-300 mb-10 transition-colors">
          <ChevronLeft className="w-3.5 h-3.5" /> Back to Library
        </Link>

        {/* Hero */}
        <div className="text-center mb-10">
          <Radio className="w-10 h-10 text-amber-400 mx-auto mb-4" />
          <h1 className="text-4xl sm:text-5xl font-black text-white tracking-tight mb-3" data-testid="radio-title">
            Federation Radio
          </h1>
          <p className="text-base sm:text-lg text-slate-400">The voice of the NextXus Federation</p>
        </div>

        {/* Player */}
        <div className="flex justify-center mb-10">
          <div className="w-full max-w-[600px] rounded-2xl overflow-hidden border border-slate-800/50 shadow-[0_0_40px_rgba(0,0,0,0.3)]">
            <iframe
              width="600"
              height="420"
              frameBorder="0"
              src="https://live365.com/embeds/v1/player/a16924?s=md&m=dark&c=mp3"
              title="Federation Radio"
              className="w-full"
              style={{ maxWidth: '100%', display: 'block', aspectRatio: '600/420' }}
              data-testid="radio-player-iframe"
            />
          </div>
        </div>

        {/* Context */}
        <div className="text-center max-w-lg mx-auto">
          <p className="text-sm text-slate-400 leading-relaxed mb-6">
            Live broadcast from the Federation network. Tune in for ambient intelligence, curated audio, and Federation communications.
          </p>
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-slate-800/40 bg-slate-900/40">
            <span className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse" />
            <span className="text-xs text-slate-400">Now Playing &mdash; NextXus Radio Live</span>
          </div>
        </div>
      </div>
    </div>
  );
}
